import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import LoginForm from '../components/LoginForm';
import { useAuth } from '../context/authContext';
import Layout from '@/components/Layout';

const LoginPage = () => {
  const { user, login, loading } = useAuth();
  const router = useRouter();
  const [error, setError] = useState('');

  useEffect(() => {
    if (!loading && user) {
      router.replace('/HomePage');
    }
  }, [user, loading, router]);

  const handleLogin = async ({ username, password }) => {
    try {
      setError('');
      await login({ username, password });
    } catch (err) {
      const msg = String(err?.message || '').toLowerCase();
      if (msg.includes('failed to fetch') || msg.includes('network') || msg.includes('timeout')) {
        setError('Tidak ada koneksi internet. Periksa jaringan Anda, lalu coba lagi.');
      } else {
        setError('Username atau password salah. Mohon periksa kembali.');
      }
    }
  };

  if (loading) {
    return null;
  }

  return (
    <Layout>
      <div className="min-h-screen bg-surface-muted">
        {/* Header maroon dengan logo & sambutan */}
        <div className="relative overflow-hidden rounded-b-[28px] bg-brand-gradient px-6 pb-12 pt-8 text-white">
          <div className="pointer-events-none absolute inset-0 opacity-30" aria-hidden>
            <svg className="absolute -right-12 -top-10 h-64 w-64" viewBox="0 0 200 200" fill="none">
              <circle cx="100" cy="100" r="80" stroke="white" strokeWidth="0.5" />
              <circle cx="100" cy="100" r="55" stroke="white" strokeWidth="0.5" />
              <circle cx="100" cy="100" r="30" stroke="white" strokeWidth="0.5" />
            </svg>
            {Array.from({ length: 24 }).map((_, i) => (
              <span
                key={i}
                className="absolute inline-block h-0.5 w-0.5 rounded-full bg-white/70"
                style={{ top: `${(i * 37) % 100}%`, left: `${(i * 53) % 100}%` }}
              />
            ))}
          </div>

          <div className="relative">
            <img
              src="/images/logo_SAIM.png"
              alt="Sekolah Adab Insan Mulia"
              className="h-14 w-14 object-contain drop-shadow"
            />
            <h1 className="mt-5 text-2xl font-extrabold">
              Assalamu&rsquo;alaikum! <span className="inline-block">👋</span>
            </h1>
            <p className="mt-2 max-w-xs text-sm leading-relaxed text-white/85">
              Silahkan masukkan username dan kata sandi yang diberikan oleh pihak sekolah.
            </p>
          </div>
        </div>

        {/* Form */}
        <div className="-mt-5 px-5">
          <LoginForm onLogin={handleLogin} error={error} />
        </div>
      </div>
    </Layout>
  );
};

export default LoginPage;
